import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useDeleteFlow = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const {
    isLoading, isError, isSuccess, mutate, mutateAsync,
  } = useMutation(
    ({ flowId, crId }) => axiosInstance.delete(flow(orgId).delete(flowId, crId)),
    {
      onSuccess: (response) => {
        const { cancelledRunCount = 0 } = response?.data || {};
        const message = cancelledRunCount > 0
          ? `Flow deleted. ${cancelledRunCount} active run${cancelledRunCount === 1 ? ' was' : 's were'} cancelled.`
          : 'Flow has been deleted.';

        dispatch(showAlert({
          message,
          type: 'success',
        }));
      },
      onError: (error) => dispatch(showAlert({
        message: error.response?.data?.message || 'Failed to delete flow',
        type: 'error',
      })),
    },
  );
  return {
    isLoading, isError, isSuccess, mutate, mutateAsync,
  };
};
